import { render, staticRenderFns } from "./ConcentrationBreakdownMethodology.vue?vue&type=template&id=22ab4cec&"
import script from "./ConcentrationBreakdownMethodology.vue?vue&type=script&lang=js&"
export * from "./ConcentrationBreakdownMethodology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports